<template>
  <forms-list-activity :form-type="FORM_TYPE" ref="formList"
     :customAdd = "true"
     @add="customAdd"

     :customDetails = "true"
     @details="customDetails"
  >
  </forms-list-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import Perms from "@/server/Perms";
import PermissionsSet from "@/server/PermissionsSet";
import FooterButton from "@/components/navbar/FooterButton";
import Log from "@/utils/Log";
import DialogManager from "@/utils/DialogManager";
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity";
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import FormsLoader from "@/components/forms/FormsLoader";
import BookHealthcheck from "@/server/com/silkplm/model/healthcheck/BookHealthcheck";

const FORM_TYPE = BookHealthcheck;

export default {
  name: "FormListActivityTemplate",
  components: {FormsListActivity},
  permission: () => FormsLoader.formPermission(FORM_TYPE),


  methods: {
    ...Activity.methods,

    getTitle() {
      return this.$refs.formList?.getTitle() ?? $tr('titleInCaseOfFull','Title in case of null');
    },


    async customAdd(){
      Log.debug("Wow!");
      await DialogManager.info($tr('newClicked','New clicked'), $tr('newButtonWasClicked','A new button was clicked'));
    },

    async customDetails(){
      Log.debug("Wow!");
      await DialogManager.info($tr('newClicked','New clicked'), $tr('newButtonWasClicked','A new button was clicked'));
    },



  },
  data:function(){return {
    FORM_TYPE,
    unsavedChanges: false,
    permissions: new PermissionsSet(),
  }}
}
</script>
